import React from "react";
import { HyperLink } from "../HyperLink";

export interface Props {
  itemsList: {
    url?: string;
    text: string;
    variants?: string;
    onClick?: () => void;
  }[];
}

export const HyperLinksList = (props: Props) => {
  if (props.itemsList && props.itemsList.length === 1) {
    const item = props.itemsList[0];
    return (
      <p>
        {item.url ? (
          <HyperLink
            url={item.url}
            text={item.text}
            variants="inPageLink"
            classes="ons-list__link"
            onClick={item.onClick}
          />
        ) : (
          item.text
        )}
      </p>
    );
  } else {
    return (
      <ol className="ons-list">
        {props.itemsList.map((item, index) => (
          <li key={index} className="ons-list__item">
            {item.url ? (
              <HyperLink
                url={item.url}
                text={item.text}
                variants="inPageLink"
                classes="ons-list__link"
                onClick={item.onClick}
              />
            ) : (
              item.text
            )}
          </li>
        ))}
      </ol>
    );
  }
};
